import { Component, OnInit } from "@angular/core";

@Component({
    selector: "shell-layout",
    templateUrl: "./layout.component.html"
})
export class ShellLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
